import service from '@/utils/server';
let modelPath = '/fm/oauthClient';
export const queryList = data => {
    return service({
        url: modelPath+'/pageInfo',
        method: 'post',
        data
    })
};
//
export const getAddClient = data => {
  return service({
    url: modelPath+'/add',
    method: 'post',
    data
  })
};

//
export const getUpdateClient = data => {
  return service({
    url: modelPath+'/update',
    method: 'post',
    data
  })
};


//
export const getUpdateClientList = data => {
  return service({
    url: modelPath+'/updateSecret',
    method: 'post',
    data
  })
};
export const getResetClientSecret = data => {
  return service({
    url: modelPath+'/resetSecret',
    method: 'post',
    data
  })
};
//
export const getDeleteClientList = data => {
  return service({
    url: modelPath+'/delete/'+data.id,
    method: 'post'
  })
};

export const getInitUserInfo = data => {
  return service({
    url: modelPath+'/initUserVO',
    method: 'post',
    data
  })
};

export const getInitMenuInfo = data => {
  return service({
    url: modelPath+'/initMenuVO',
    method: 'post',
    data
  })
};

export const getInitClientInfo = data => {
  return service({
    url: modelPath+'/initClientVO',
    method: 'post',
    data
  })
};

export const getInitRoleInfo = data => {
  return service({
    url: modelPath+'/initRoleVO',
    method: 'post',
    data
  })
};

export const getInitPermissionInfo = data => {
  return service({
    url: modelPath+'/initPermissionVO',
    method: 'post',
    data
  })
};

export const getInitPageOpInfo = data => {
  return service({
    url: modelPath+'/initPageOpVO',
    method: 'post',
    data
  })
};
export const getExportClientData = data => {
  return service({
    url: modelPath+'/exportClient/' + data.clientId,
    method: 'post'
  })
};



// WEBPACK FOOTER //
// ./src/page/auth/client/api/index.js